const areMandatoryAddonsSelected = (checkedItems, addOns) => {
    const selectedAddon = Object.keys(checkedItems).filter(key => checkedItems[key]);
    const allMandatoryAddons = addOns.filter(addon => addon.isMandatory).map(addon => addon.id);
    return allMandatoryAddons.every(id => selectedAddon.includes(id));
}

export default areMandatoryAddonsSelected;